module.exports = __webpack_public_path__ + "img/DFDFCA_4D2D07_6B5224_857145-256px.3385ee16.png";